// extracted by css-extract-rspack-plugin
export default {"titleRow":"titleRow-jB8xlu"};